import React from 'react';
import { css } from '@emotion/core';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import { line, system300 } from 'Mui/styles/color';
import Button from 'Mui/Button';
import DialogSystem from 'client/components/DialogSystem';
import useLoginUrl from 'client/hooks/login/useLoginUrl';
import useLoginLinkClickAction from 'client/hooks/login/useLoginLinkAction';
import { loginTypesForApi } from 'config/loginTypes';
import PrivacyLink from 'client/components/dialogLogin/PrivacyLink';

function DialogLineAddFriend({ open, onClose }) {
    const { privacyUrl, privacyText } = useSelector(s => s.sponsor);
    const loginUrl = useLoginUrl({
        loginType: loginTypesForApi.LINE,
        additionalQsObj: { prompt: 'consent' }
    });
    const { target, href, onClick } = useLoginLinkClickAction({ loginUrl });

    return (
        <DialogSystem
            isOpen={open}
            title={i18n.t('label.line_login.add_friend_first')}
            body={
                <>
                    <div css={contentStyle}>
                        <div css={btnContainerStyle}>
                            <a href={href} target={target} onClick={onClick} css={linkStyle}>
                                <Button css={[buttonStyle]}>
                                    <span css={iconStyle} />
                                    <Divider css={dividerStyle} orientation="vertical" flexItem />
                                    {i18n.t('label.login.line_add_friend')}
                                </Button>
                            </a>
                        </div>
                        {privacyUrl && (
                            <PrivacyLink privacyUrl={privacyUrl} privacyText={privacyText} />
                        )}
                    </div>
                    <Typography variant="caption">
                        {i18n.t('label.login.need_line_friendship')}
                    </Typography>
                </>
            }
            endButton={null}
            closePopup={onClose}
        />
    );
}

export default DialogLineAddFriend;

const contentStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    text-align: center;
    padding: 0 0 24px;
`;

const btnContainerStyle = css`
    margin-bottom: 8px;
`;

const buttonStyle = css`
    color: #fff;
    border-radius: 8px;
    background-color: ${line.color};
    padding: 6px 6.5px;
    font-weight: bold;
    padding-left: 5px;
    &:hover {
        background-color: ${line.color};
    }
    &.Mui-disabled {
        background-color: ${system300.color};
        color: #fff;
    }
`;

const linkStyle = css`
    text-decoration: none;
`;

const iconStyle = css`
    height: 24px;
    width: 24px;
    display: block;
    background: url(https://assets.fevercdn.com/promotion/img/icon-line-login.png) 50% 50% no-repeat;
    background-size: contain;
`;

const dividerStyle = css`
    margin: -6px 5px;
`;
